/* global axios */
import { DataManager } from '../helper/CacheHelper/DataManager';
import ApiClient from './ApiClient';

// UMA PERGUNTA PELAS CHAVES, NÃO TRÊS (06/10/2026, missão de velocidade).
// Caixas, etiquetas e times abrem juntos e cada um perguntava as mesmas
// chaves de cache: três `cache_keys` iguais em toda tela. Quem pergunta nos
// próximos 3 segundos recebe a mesma resposta (a mesma promessa).
const RESPOSTA_DAS_CHAVES = {};
const VALIDADE_DAS_CHAVES = 3000;
export const buscarChavesDeCache = conta => {
  const guardada = RESPOSTA_DAS_CHAVES[conta];
  if (guardada && Date.now() - guardada.em < VALIDADE_DAS_CHAVES) {
    return guardada.promessa;
  }
  const promessa = axios.get(`/api/v1/accounts/${conta}/cache_keys`);
  RESPOSTA_DAS_CHAVES[conta] = { promessa, em: Date.now() };
  promessa.catch(() => delete RESPOSTA_DAS_CHAVES[conta]);
  return promessa;
};

class CacheEnabledApiClient extends ApiClient {
  constructor(resource, options = {}) {
    super(resource, options);
    this.gerentesPorConta = {};
  }

  // O banco local tem a conta no nome (`cw-store-1`). Era escolhido UMA vez,
  // quando o código carregava — e com os endereços limpos (06/10/2026) a
  // conta pode ainda não ser conhecida nesse instante (`/processos` num
  // navegador que nunca abriu o app). Agora é escolhido a cada uso, pela
  // conta da tela: o cache nunca vai para o banco de outra conta.
  get dataManager() {
    const conta = this.accountIdFromRoute;
    if (!this.gerentesPorConta[conta]) {
      this.gerentesPorConta[conta] = new DataManager(conta);
    }
    return this.gerentesPorConta[conta];
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    throw new Error('cacheModelName is not defined');
  }

  get(cache = false) {
    if (cache) {
      return this.getFromCache();
    }

    return this.getFromNetwork();
  }

  getFromNetwork() {
    return axios.get(this.url);
  }

  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data.payload;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: { payload: dataToParse } };
  }

  async getFromCache() {
    try {
      // IDB is not supported in Firefox private mode: https://bugzilla.mozilla.org/show_bug.cgi?id=781982
      await this.dataManager.initDb();
    } catch {
      return this.getFromNetwork();
    }

    const { data } = await buscarChavesDeCache(this.accountIdFromRoute);
    const cacheKeyFromApi = data.cache_keys[this.cacheModelName];
    const isCacheValid = await this.validateCacheKey(cacheKeyFromApi);

    let localData = [];
    if (isCacheValid) {
      localData = await this.dataManager.get({
        modelName: this.cacheModelName,
      });
    }

    if (localData.length === 0) {
      return this.refetchAndCommit(cacheKeyFromApi);
    }

    return this.marshallData(localData);
  }

  async refetchAndCommit(newKey = null) {
    const response = await this.getFromNetwork();

    try {
      await this.dataManager.initDb();

      this.dataManager.replace({
        modelName: this.cacheModelName,
        data: this.extractDataFromResponse(response),
      });

      await this.dataManager.setCacheKeys({
        [this.cacheModelName]: newKey,
      });
    } catch {
      // Ignore error
    }

    return response;
  }

  async validateCacheKey(cacheKeyFromApi) {
    if (!this.dataManager.db) {
      await this.dataManager.initDb();
    }

    const cachekey = await this.dataManager.getCacheKey(this.cacheModelName);
    return cacheKeyFromApi === cachekey;
  }
}

export default CacheEnabledApiClient;
